import Communities from './Communities';

export default Communities;
